/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SurveyComments from './survey-comments';
import SurveyCommentsDetail from './survey-comments-detail';
import SurveyCommentsUpdate from './survey-comments-update';
import SurveyCommentsDeleteDialog from './survey-comments-delete-dialog';

const SurveyCommentsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SurveyComments />} />
    <Route path="new" element={<SurveyCommentsUpdate />} />
    <Route path=":id">
      <Route index element={<SurveyCommentsDetail />} />
      <Route path="edit" element={<SurveyCommentsUpdate />} />
      <Route path="delete" element={<SurveyCommentsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SurveyCommentsRoutes;
